import io from 'socket.io-client';

const socket = io(
    process.env.REACT_APP_API_URL,
    {
        autoConnect: false,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 10,
        closeOnBeforeunload: true
    }
);

export default socket;